// extracted by mini-css-extract-plugin
module.exports = {"container":"emptyContent_container__hrZGX","label":"emptyContent_label__1Y4lJ"};